import { render } from "./CardLinks.vue?vue&type=template&id=cc632c00&scoped=true"
import script from "./CardLinks.vue?vue&type=script&lang=js"
export * from "./CardLinks.vue?vue&type=script&lang=js"

import "./CardLinks.vue?vue&type=style&index=0&id=cc632c00&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cc632c00"

export default script